import { mediaUrl } from "@/lib/api";
import { initials } from "@/lib/format";

export function BrandMark({ className = "h-8 w-8" }) {
  return (
    <div className={`${className} rounded-xl bg-amber-500 flex items-center justify-center shrink-0`}>
      <span className="font-display font-extrabold text-ink text-[0.8em] leading-none" style={{ fontSize: "0.9rem" }}>G</span>
    </div>
  );
}

export function BrandLogo({ className = "", withTagline = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <BrandMark />
      <div className="min-w-0">
        <span className="font-display font-bold text-lg tracking-tight text-white block leading-none">Gesppy</span>
        {withTagline && <span className="text-[11px] text-zinc-500 block mt-1">Gestão inteligente para o seu negócio</span>}
      </div>
    </div>
  );
}

export function BusinessAvatar({ business, className = "h-12 w-12", textClass = "text-base" }) {
  if (business?.logo_url) {
    return <img src={mediaUrl(business.logo_url)} alt={business.name} className={`${className} rounded-2xl object-cover`} />;
  }
  return (
    <div className={`${className} rounded-2xl flex items-center justify-center bg-[var(--brand)] text-ink font-display font-bold ${textClass}`}>
      {initials(business?.name || "B")}
    </div>
  );
}

export function BusinessBrand({ business, plan, className = "" }) {
  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`} data-testid="business-brand">
      <BusinessAvatar business={business} className="h-10 w-10" textClass="text-sm" />
      <div className="min-w-0">
        <p className="font-display font-bold text-base tracking-tight text-white truncate leading-tight" data-testid="sidebar-business-name">{business.name}</p>
        {plan && <p className="text-[10px] uppercase tracking-wider text-amber-400 font-bold" data-testid="sidebar-plan-name">Plano {plan}</p>}
      </div>
    </div>
  );
}

export function PersonAvatar({ name, photo, className = "h-11 w-11", color }) {
  if (photo) return <img src={mediaUrl(photo)} alt={name} className={`${className} rounded-full object-cover`} />;
  return (
    <div className={`${className} rounded-full flex items-center justify-center font-semibold text-sm text-ink`} style={{ background: color || "#A1A1AA" }}>
      {initials(name)}
    </div>
  );
}
